module.exports = __webpack_public_path__ + "static/favicon-f1c2bfa2722e3a9be7a5523c857f6f01.png";